(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["barbour-hero"] && !Shopify.designMode) return;
  try {
    
function initBarbourBanner(root=document){
 root.querySelectorAll('.barbour-hero__video').forEach(video=>{
  if(video.dataset.ready)return;
  video.dataset.ready='true';
  const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
  video.muted=true;video.defaultMuted=true;video.playsInline=true;
  const play=()=>{if(!motion.matches&&!document.hidden){const result=video.play();if(result)result.catch(()=>{});}};
  video.addEventListener('canplay',play,{once:true});
  window.addEventListener('pageshow',play);
  document.addEventListener('visibilitychange',()=>{if(document.hidden)video.pause();else play();});
  motion.addEventListener('change',()=>{if(motion.matches)video.pause();else play();});
  play();
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initBarbourBanner(),{once:true});else initBarbourBanner();
document.addEventListener('shopify:section:load',event=>initBarbourBanner(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nn07-fracap-hero"] && !Shopify.designMode) return;
  try {
    
function initFracapHero(root=document){
  root.querySelectorAll('.fracap-hero').forEach(section=>{
    if(section.dataset.initialized)return;
    section.dataset.initialized='true';
    const video=section.querySelector('video');
    const poster=section.querySelector('.fracap-hero__poster');
    const start=section.querySelector('.fracap-hero__start');
    const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobile=window.matchMedia('(max-width: 749px)').matches;
    let pending=false;
    let visible=true;
    const fallback=()=>{poster.hidden=false;start.hidden=false;};
    const play=(manual=false)=>{
      if(pending||!video.paused||(!manual&&(motion.matches||document.hidden||!visible)))return;
      pending=true;
      video.muted=true;
      try{
        const result=video.play();
        if(result&&typeof result.then==='function')result.then(()=>{pending=false;}).catch(()=>{pending=false;fallback();});
        else pending=false;
      }catch(error){pending=false;fallback();}
    };
    video.muted=true;
    video.defaultMuted=true;
    video.playsInline=true;
    video.autoplay=!motion.matches;
    video.addEventListener('playing',()=>{poster.hidden=true;start.hidden=true;});
    video.addEventListener('pause',fallback);
    video.addEventListener('error',fallback);
    video.addEventListener('loadeddata',()=>play(),{once:true});
    video.addEventListener('canplay',()=>play(),{once:true});
    start.addEventListener('click',()=>{if(video.error)video.load();play(true);});
    const resume=()=>play();
    const visibility=()=>{if(document.hidden)video.pause();else play();};
    window.addEventListener('pageshow',resume);
    document.addEventListener('visibilitychange',visibility);
    const onMotion=()=>{video.autoplay=!motion.matches;if(motion.matches)video.pause();else play();};
    if(motion.addEventListener)motion.addEventListener('change',onMotion);
    let observer;
    if('IntersectionObserver' in window){
      observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;if(visible)play();else video.pause();},{threshold:0.1});
      observer.observe(video);
    }
    const unload=event=>{
      if(!event.target.contains(section))return;
      if(observer)observer.disconnect();
      video.pause();
      window.removeEventListener('pageshow',resume);
      document.removeEventListener('visibilitychange',visibility);
      if(motion.removeEventListener)motion.removeEventListener('change',onMotion);
      document.removeEventListener('shopify:section:unload',unload);
    };
    document.addEventListener('shopify:section:unload',unload);
    fallback();
    video.src=(mobile?video.dataset.mobileSrc:video.dataset.desktopSrc)||video.dataset.desktopSrc||video.dataset.mobileSrc;
    video.load();
    play();
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initFracapHero(),{once:true});
else initFracapHero();
document.addEventListener('shopify:section:load',event=>initFracapHero(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["serviceworks-hero"] && !Shopify.designMode) return;
  try {
    
function initServiceWorksHero(root=document){
  root.querySelectorAll('.sw-hero').forEach(section=>{
    if(section.dataset.initialized)return;
    section.dataset.initialized='true';
    const video=section.querySelector('video');
    const poster=section.querySelector('.sw-hero__poster');
    const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobile=window.matchMedia('(max-width: 749px)').matches;
    let pending=false;
    let visible=true;
    const fallback=()=>{poster.hidden=false;};
    const play=(manual=false)=>{
      if(pending||!video.paused||(!manual&&(motion.matches||document.hidden||!visible)))return;
      pending=true;
      video.muted=true;
      try{
        const result=video.play();
        if(result&&typeof result.then==='function')result.then(()=>{pending=false;}).catch(()=>{pending=false;fallback();});
        else pending=false;
      }catch(error){pending=false;fallback();}
    };
    video.muted=true;
    video.defaultMuted=true;
    video.playsInline=true;
    video.autoplay=!motion.matches;
    video.addEventListener('playing',()=>{poster.hidden=true;});
    video.addEventListener('pause',fallback);
    video.addEventListener('error',fallback);
    video.addEventListener('loadeddata',()=>play(),{once:true});
    video.addEventListener('canplay',()=>play(),{once:true});
    const resume=()=>play();
    const visibility=()=>{if(document.hidden)video.pause();else play();};
    window.addEventListener('pageshow',resume);
    document.addEventListener('visibilitychange',visibility);
    const onMotion=()=>{video.autoplay=!motion.matches;if(motion.matches)video.pause();else play();};
    if(motion.addEventListener)motion.addEventListener('change',onMotion);
    let observer;
    if('IntersectionObserver' in window){
      observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;if(visible)play();else video.pause();},{threshold:0.1});
      observer.observe(video);
    }
    const unload=event=>{
      if(!event.target.contains(section))return;
      if(observer)observer.disconnect();
      video.pause();
      window.removeEventListener('pageshow',resume);
      document.removeEventListener('visibilitychange',visibility);
      if(motion.removeEventListener)motion.removeEventListener('change',onMotion);
      document.removeEventListener('shopify:section:unload',unload);
    };
    document.addEventListener('shopify:section:unload',unload);
    fallback();
    video.src=(mobile?video.dataset.mobileSrc:video.dataset.desktopSrc)||video.dataset.desktopSrc||video.dataset.mobileSrc;
    video.load();
    play();
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initServiceWorksHero(),{once:true});
else initServiceWorksHero();
document.addEventListener('shopify:section:load',event=>initServiceWorksHero(event.target));

  } catch(e) { console.error(e); }
})();
})();
